import { nameof } from 'ts-simple-nameof';
import * as yup from 'yup';
import { customNullable } from '..';
import type { TravelAddonsDto } from '../../dtos';

export const TravelAddonValidationSchema = yup.object().shape({
    [nameof<TravelAddonsDto>(x => x.vehicleAssistanceAvailable)]: yup.boolean(),
    [nameof<TravelAddonsDto>(x => x.vehicleAssistanceRequired)]: yup.boolean(),

    [nameof<TravelAddonsDto>(x => x.vehicleRegistrationMark)]: yup.string().
        when([nameof<TravelAddonsDto>(x => x.vehicleAssistanceAvailable), nameof<TravelAddonsDto>(x => x.vehicleAssistanceRequired)], {
            is: (allowed: boolean, required: boolean) => allowed && required,
            then: () => yup.string().nullable().required('Zadejte registrační značku'),
            otherwise: () => yup.string().nullable()
        }),

    [nameof<TravelAddonsDto>(x => x.stornoInsuranceRequired)]: yup.boolean(),
    [nameof<TravelAddonsDto>(x => x.holidayPrice)]: customNullable(yup.number()).when([nameof<TravelAddonsDto>(x => x.stornoInsuranceRequired)], {
        is: (required: boolean) => required,
        then: () => customNullable(yup.number()).nullable().required('Zadejte cenu zájezdu'),
        otherwise: () => customNullable(yup.number()).nullable()
    }),
    [nameof<TravelAddonsDto>(x => x.holidayPricePerPerson)]: customNullable(yup.number()).when([nameof<TravelAddonsDto>(x => x.stornoInsuranceRequired)], {
        is: (required: boolean) => required,
        then: () => customNullable(yup.number()).nullable().required('Zadejte cenu zájezdu za 1 osobu'),
        otherwise: () => customNullable(yup.number()).nullable()
    }),

    [nameof<TravelAddonsDto>(x => x.stornoInsuranceRequired)]: yup.boolean(),
    [nameof<TravelAddonsDto>(x => x.holidayPurchaseDate)]: yup.date().when([nameof<TravelAddonsDto>(x => x.stornoInsuranceRequired)], {
        is: (required: boolean) => required,
        then: () => yup.date().nullable().required('Zadejte datum zakoupení zájezdu'),
        otherwise: () => yup.date().nullable()
    }),
}) as any
